import { gql } from '@/__generated__/gql';

export const STRATEGY_DETAILS_PAGE_LIST_DUE_DILIGENCE_FUNNELS_QUERY = gql(`
  query StrategyDetailsPageListDueDiligenceFunnels($data: DueDiligenceFunnelListDto!) {
    listDueDiligenceFunnels(data: $data) {
      id
      name
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_GET_DUE_DILIGENCE_RECORD_QUERY = gql(`
  query StrategyDetailsPageGetDueDiligenceRecord($id: String!, $strategyId: String) {
    getDueDiligenceRecord(id: $id, strategyId: $strategyId) {
      id
      status
      approver {
        id
        firstName
        lastName
      }
      statusUpdatedAt
      note
      createdAt
      owner {
        id
        firstName
        lastName
      }
      funnel {
        id
        name
        docxTemplateStorageKey
        tiers {
          id
          name
          tasksCount
          data {
            id
            status
            approver {
              id
              firstName
              lastName
            }
            statusUpdatedAt
          }
          sections {
            id
            userCanScore
            data {
              id
              score
              completed
            }
          }
        }
      }
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_START_DUE_DILIGENCE_MUTATION = gql(`
  mutation StrategyDetailsPageStartDueDiligence($investmentId: String!) {
    startDueDiligence(investmentId: $investmentId) {
      fromStateId
      toStateId
    }
  }
`);

export const STRATEGY_DETAILS_PAGE_DELETE_DUE_DILIGENCE_RECORD_MUTATION = gql(`
  mutation StrategyDetailsPageDeleteDueDiligenceRecord($id: String!) {
    deleteDueDiligenceRecord(id: $id)
  }
`);
